import { useEffect, useState } from 'react';
import { Step1Negocio } from './onboarding/Step1Negocio';
import { Step2Branding } from './onboarding/Step2Branding';
import { Step3Impuestos } from './onboarding/Step3Impuestos';
import { Step4Dueno } from './onboarding/Step4Dueno';
import { Step5Demo } from './onboarding/Step5Demo';

interface Props {
  onComplete: () => void;
}

const TOTAL_PASOS = 5;

export function OnboardingPage({ onComplete }: Props) {
  const [pasoActual, setPasoActual] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await window.api.onboarding.estado();
      if (res.ok && res.data.pasoActual >= 1 && res.data.pasoActual <= TOTAL_PASOS) {
        setPasoActual(res.data.pasoActual);
      }
    })();
  }, []);

  const handleSiguiente = (siguientePaso: number) => {
    if (siguientePaso > TOTAL_PASOS) {
      finalizar();
    } else {
      setPasoActual(siguientePaso);
    }
  };

  const handleAtras = () => {
    if (pasoActual > 1) setPasoActual(pasoActual - 1);
  };

  const finalizar = async () => {
    const res = await window.api.onboarding.completar();
    if (res.ok) onComplete();
  };

  return (
    <div className="flex h-full flex-col bg-white">
      <header className="flex items-center justify-between border-b border-slate-200 px-8 py-4">
        <div className="flex items-center gap-3">
          <div className="text-xl font-bold text-primary">RestaurantPOS</div>
          <span className="text-sm text-slate-500">— Configuración inicial</span>
        </div>
        <Stepper actual={pasoActual} total={TOTAL_PASOS} />
      </header>

      <div className="flex-1 overflow-auto px-8 py-8">
        {pasoActual === 1 && <Step1Negocio onSiguiente={() => handleSiguiente(2)} />}
        {pasoActual === 2 && <Step2Branding onSiguiente={() => handleSiguiente(3)} onAtras={handleAtras} />}
        {pasoActual === 3 && <Step3Impuestos onSiguiente={() => handleSiguiente(4)} onAtras={handleAtras} />}
        {pasoActual === 4 && <Step4Dueno onSiguiente={() => handleSiguiente(5)} onAtras={handleAtras} />}
        {pasoActual === 5 && <Step5Demo onFinalizar={finalizar} onAtras={handleAtras} />}
      </div>
    </div>
  );
}

function Stepper({ actual, total }: { actual: number; total: number }) {
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: total }).map((_, i) => {
        const n = i + 1;
        const activo = n === actual;
        const completado = n < actual;
        return (
          <div
            key={n}
            className={`h-2.5 w-2.5 rounded-full ${
              activo ? 'bg-primary' : completado ? 'bg-primary/50' : 'bg-slate-300'
            }`}
            aria-label={`Paso ${n} ${activo ? '(actual)' : completado ? '(completado)' : ''}`}
          />
        );
      })}
      <span className="ml-2 text-xs text-slate-500">{actual}/{total}</span>
    </div>
  );
}
